import Model from 'flarum/common/Model';

export default class Artist extends Model {
  slug = Model.attribute('slug');
  translation = Model.attribute('translation');
  name = Model.attribute('name');
  type = Model.attribute('type');
  roles = Model.attribute('roles');
  projects = Model.attribute('projects');
  aliases = Model.attribute('aliases');
  activeYears = Model.attribute('activeYears');
  genres = Model.attribute('genres');
  description = Model.attribute('description');
  clubSlugs = Model.attribute('clubSlugs');
  forumMentions = Model.attribute('forumMentions');
  hasStory = Model.attribute('hasStory');
  isIndexed = Model.attribute('isIndexed');
  realName = Model.attribute('realName');
  members = Model.attribute('members');
  bioHtml = Model.attribute('bioHtml');
  timeline = Model.attribute('timeline');
  clubs = Model.attribute('clubs');
  releases = Model.attribute('releases');
  tracks = Model.attribute('tracks');
  anecdotes = Model.attribute('anecdotes');
  links = Model.attribute('links');
  sources = Model.attribute('sources');
  searchNames = Model.attribute('searchNames');
  media = Model.attribute('media');
  isVerified = Model.attribute('isVerified');

  /** Rollen, belangrijkste eerst (dj, producer, live, mc, organisator, project). */
  roleList() {
    const legacy = { producer: 'producer', project: 'project', duo: 'project', mc: 'mc', live: 'live' };
    return (this.roles() && this.roles().length ? this.roles() : [legacy[this.type()] || 'dj']).slice();
  }

  isProject() {
    return this.roleList().includes('project');
  }

  /** Weergavenamen van zichtbare aliassen (zonder "Naam (Echte Naam)"-vormen). */
  shownAliases() {
    return (this.aliases() || []).filter((a) => a.indexOf('(') === -1 && a !== this.name());
  }

  searchText() {
    return [this.name(), ...(this.aliases() || [])].filter(Boolean).join(' ').toLowerCase();
  }
}
